import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel-grid__block" }
const _hoisted_2 = {
  key: 1,
  class: "profile-headline"
}
const _hoisted_3 = { class: "profile-headline__text-wrapper" }
const _hoisted_4 = { class: "profile-headline__title" }
const _hoisted_5 = { class: "profile-panel__row investment-level" }
const _hoisted_6 = {
  key: 0,
  class: "profile-headline"
}
const _hoisted_7 = { class: "profile-headline__text-wrapper" }
const _hoisted_8 = { class: "profile-headline__title" }
const _hoisted_9 = { class: "level-wrapper" }
const _hoisted_10 = {
  key: 0,
  alt: "level indicator",
  class: "investment-level__indicator investment-level__indicator--disabled",
  src: "/img/placeholders/level.svg"
}
const _hoisted_11 = {
  key: 2,
  class: "investment-level__description"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "investment-level__cta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvestmentLevelPanelPlaceholder = _resolveComponent("InvestmentLevelPanelPlaceholder")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_InvestmentLevelPanelPlaceholder, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.$screen.smDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("profile.investors.panel.title")), 1)
          ]),
          (_ctx.allowLevelUpdate)
            ? (_openBlock(), _createBlock(_component_PxButton, {
                key: 0,
                disabled: !_ctx.$features.isEnabled('updateLevel'),
                class: "profile-headline__updateBtn",
                size: "small",
                onClick: _ctx.onClickUpdateLevel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile.investors.panel.update")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PxPanel, {
          key: 2,
          class: _normalizeClass([{ 'profile-panel--disabled': _ctx.isInactive }, "profile-panel"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.$screen.smDown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("profile.investors.panel.title")), 1)
                    ]),
                    (_ctx.allowLevelUpdate)
                      ? (_openBlock(), _createBlock(_component_PxButton, {
                          key: 0,
                          disabled: !_ctx.$features.isEnabled('updateLevel'),
                          class: "profile-headline__updateBtn",
                          size: "small",
                          onClick: _ctx.onClickUpdateLevel
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("profile.investors.panel.update")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.isInactive)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : (_openBlock(), _createBlock(_component_PxIcon, {
                      key: 1,
                      name: `level-range-graph/level-${_ctx.investingLevelRangeInterval}`,
                      size: _ctx.$screen.mdUp ? 173 : 140,
                      class: "investment-level__indicator"
                    }, null, 8, ["name", "size"])),
                (!_ctx.isInactive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.investingLevelRangeTitle) + " ", 1),
                        _createVNode(_component_ElTooltip, {
                          placement: "top",
                          "popper-class": "investment-level__tooltip el-abaca-tooltip"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", { innerHTML: _ctx.investingLevelRangeDescription }, null, 8, _hoisted_12)
                          ]),
                          default: _withCtx(() => [
                            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-question" }, null, -1))
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.$user.isOwner() && _ctx.$features.isEnabled('match'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_PxButton, {
                      size: "large",
                      type: "green",
                      onClick: _ctx.onClickMatching
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("profile.investors.panel.matchButton")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}